import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";

const ITCompleteWork = () => {
  const userId = localStorage.getItem("userId");
  const adminName = localStorage.getItem("adminName");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [pageLoad, setPageLoad] = useState(false);
  const [subDropdownOpen, setSubDropdownOpen] = useState(null); // Manage sub-dropdown states
  // Toggle sub-dropdown based on index
  const toggleSubDropdown = (index) => {
    setSubDropdownOpen((prev) => (prev === index ? null : index)); // Open the clicked dropdown and close others
  };
  const [query, setQuery] = useState("");
  // const navigate = useNavigate();

  const [filterData, setFilterData] = useState([]);
  const [ITCData, setITCData] = useState([]);
  const getITCData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-itc-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        setITCData(result.users);
        setFilterData(result.users);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getITCData();
  }, [userId, pageLoad]);

  const deleteITWork = async (id) => {
    const response = await fetch(`${api_url}/api/users/delete-itwork`, {
      method: "POST",
      body: JSON.stringify({
        id,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.status === 201) {
      toast.success(result.message);
      setTimeout(() => {
        setPageLoad(true);
      }, 1000);
    } else {
      toast.error(result.message);
    }
  };

  const handleFilterData = (query) => {
    const lowerCaseQuery = query.toLowerCase();
    const filteredItems = ITCData.filter((admin) => {
      let abc = JSON.parse(admin.employeeDetails);
      return (
        admin.empName.toLowerCase().includes(lowerCaseQuery) ||
        abc.EmpDesignation.toLowerCase().includes(lowerCaseQuery) ||
        abc.officeName.toLowerCase().includes(lowerCaseQuery) ||
        abc.payScale.includes(lowerCaseQuery) ||
        abc.financialYear.includes(lowerCaseQuery)
      );
    });

    setFilterData(filteredItems);
  };

  return (
    <div className="container py-3">
      <div className="all-itc-data">
        <div className="row align-items-center mb-3">
          <div className="col-lg-2 col-4">
            <Link
              className="btn btn-sm btn-danger"
              to={"/dashboard/user_incometax"}
            >
              Back
            </Link>
          </div>
          <div className="col-lg-7 col-8">
            <h1 className="text-center display-6 fw-bold text-red-500">
              All Completed Data
            </h1>
          </div>
          <div className="col-lg-3 col-12">
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1">
                <i className="fas fa-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search Here..."
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  handleFilterData(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="table-responsive  overflow-x-auto">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Designation</th>
                    <th scope="col">Office Name</th>
                    <th scope="col">Pay Scale</th>
                    <th scope="col">Fin. Year</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filterData &&
                    filterData.map((item, index) => {
                      let abc = JSON.parse(item.employeeDetails);
                      return (
                        <tr>
                          <th scope="row">{index + 1}</th>
                          <td>{item.empName}</td>
                          <td>{abc.EmpDesignation}</td>
                          <td>{abc.officeName}</td>
                          <td>{abc.payScale}</td>
                          <td>{abc.financialYear}</td>
                          <td>
                            <Link
                              to={`/dashboard/edit_income_tax_table/${item._id}`}
                              className="btn btn-primary btn-sm ms-1"
                            >
                              <i className="fa fa-edit"></i>Edit
                            </Link>
                            <Link
                              to={`/dashboard/print_income_tax_table/${item._id}`}
                              className="btn btn-success   btn-sm ms-1"
                            >
                              <i className="fa fa-print"></i>Print
                            </Link>
                            <Link
                              to={`/dashboard/excel_income_tax_table/${item._id}`}
                              className="btn btn-success   btn-sm ms-1"
                            >
                              <i className="fa fa-print"></i>Excel
                            </Link>
                            {adminName && (
                              <button
                                className="btn btn-sm btn-outline-danger ms-1"
                                onClick={() => deleteITWork(item._id)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ITCompleteWork;
